/* eslint-disable no-console */
import { Socket } from 'socket.io-client';

import { SESSION_KEYS } from 'utils/storage';
import { hasWorkOSOverride } from 'utils/workos';

export interface SocketResProps {
  message: string;
  status: boolean;
}

export function socketInit(socket: Socket, accessToken: string) {
  if (socket.connected) {
    return;
  }
  const token = sessionStorage.getItem(SESSION_KEYS.SOCKET_ACCESS_TOKEN) || accessToken;
  socket.auth = { authorization: token };
  socket.connect();
}
export function socketClose(socket: Socket) {
  socket.auth = { authorization: '' };
  socket.disconnect();
}

export async function socketReconnect(socket: Socket, refreshToken: string) {
  if (!refreshToken) {
    return console.warn('No refresh token available');
  }
  try {
    socketClose(socket);
    const headers: Record<string, string> = {
      'API-KEY': import.meta.env.VITE_API_KEY ?? '',
      'Content-Type': 'application/json'
    };
    if (hasWorkOSOverride()) {
      headers['X-WorkOS-Override'] = 'true';
    }
    const res = await fetch(import.meta.env.VITE_BASE_URL + '/auth/token-renewal', {
      body: JSON.stringify({ refreshToken }),
      credentials: 'include',
      headers,
      method: 'POST'
    });
    const data = await res.json();
    socketInit(socket, data.data?.accessToken || '');
  } catch (e) {
    console.warn(e);
  }
}

export const errorCallBack = (event: string, res: SocketResProps | Error) => {
  if ('status' in res && res.status) {
    console.log(`socket ${event} => ${res.message}`);
  } else {
    console.error(`socket ${event} error => ${res.message}`);
  }
};
